export const cspRules = [
  "base-uri 'none'",
  "connect-src 'none'",
  "default-src 'none'",
  'font-src *',
  "form-action 'none'",
  "frame-src 'none'",
  'img-src * data:',
  "object-src 'none'",
  "script-src 'none'",
  "style-src 'self' 'unsafe-inline'",
];

export const cspTag = `<meta httpEquiv="Content-Security-Policy" content="${cspRules.join(
  '; ',
)}" />`;
